import { render, staticRenderFns } from "./UserAvatarForm.vue?vue&type=template&id=0952a588&"
import script from "./UserAvatarForm.vue?vue&type=script&lang=js&"
export * from "./UserAvatarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports